import {Trans} from "@lingui/react";
import * as React from "react";

const OfflinePlaceholder: React.FC<{}> = () => <Trans id="OFFLINE :(" />;

export default OfflinePlaceholder;
